/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-08-15 10:48:50
 * @LastEditors: linwc
 * @LastEditTime: 2025-08-16 17:09:09
 */
import { getSdPrivateCart } from '@/api/scheme';
import { clearFunctionalInstance } from '@/components/SdFunctional';
import store from '@/store';
import { Modal } from 'ant-design-vue';
import Vue from 'vue';
import Router from 'vue-router';
import Config from './config.js';

Vue.use(Router);

const router = new Router({
  routes: Config
});

//全局前置守卫
router.beforeEach((to, from, next) => {
  // 路由跳转时，清除所有弹窗
  if (to.path !== from.path) {
    Modal.destroyAll();
    clearFunctionalInstance();
  }

  const meta = to.meta || {};
  const { requireAuth = true } = meta;

  const sessionHasLogin = JSON.parse(sessionStorage.getItem('hasLogin'));
  const {
    User: { hasLogin }
  } = store.state;
  if (!requireAuth) {
    //页面不需要登录权限。直接放行
    next();
  } else if (requireAuth && !sessionHasLogin) {
    //未登录
    dispatchUserInfo(to, from, next);
  } else if (sessionHasLogin && !hasLogin) {
    //sessionHasLogin中存在已登录状态，vuex中没有等已登录状态 说明是刷新页面
    dispatchUserInfo(to, from, next);
  } else {
    next();
  }
});

async function dispatchUserInfo(to, from, next) {
  try {
    await store.dispatch('User/getUserInfo'); // 获取用户信息
    await store.dispatch('User/getTeam'); // 获取用户权限信息

    // 获取产品分类
    getSdPrivateCart({ parentId: '1' }).then(res => {
      if (res?.data) {
        store.commit('setProdTypeList', res.data);
        window.localStorage.setItem('localProdTypeList', JSON.stringify(res.data));
      }
    });

    next({ ...to, replace: true });
  } catch ({ msg }) {
    console.log(msg);
  }
}

export default router;
